<template>
	<div>
		<a-modal okText="确定" cancelText="取消" @cancel="cancel" v-model="show" title="修改分类" @ok="comfirm">
			<template>
				<!-- 表单验证 -->
				<a-form ref="collectionForm" :form="form">
					
					<!-- id -->
					<a-form-item label="id">
						<a-input disabled v-decorator="[
							'id',
							{
							  initialValue: record.data.id,
							  rules: [{ required: true, message: `请填写名称`, whitespace: true }],
							},
						  ]" />
					</a-form-item>
					
					<!-- 分类选择 -->
					<template v-if="record.classify">
						<a-form-item label="上级分类">
							<a-select @change="getselect" v-decorator="[
								'p_id',
								{ 
									initialValue:  Number(record.data.p_id),
									rules: [{ required: true, message: '请填写'}] 
								},
							  ]">
								<a-select-option v-for="(item,index) in record.classify" :key="item.id">
									{{item.name}}
								</a-select-option>
										
							</a-select>
						</a-form-item>
					</template>					
					

					<!-- 名称 -->
					<a-form-item label="名称">
						<a-input v-decorator="[
							'name',
							{
							  initialValue: record.data.name,
							  rules: [{ required: true, message: `请填写名称`, whitespace: true }],
							},
						  ]" />
					</a-form-item>
					
					<!-- 图片icon -->
					<a-form-item label="点击更换icon(494X190)">
						<img v-decorator="[
							'icon',
							{
							  initialValue: record.data.img,
							  rules: [{ required: true, message: `请填写`, whitespace: true }],
							},
						  ]" style="width: 22%;height: 60%;cursor: pointer;" :src="record.data.img" alt="" @click="openresources(1)">
					</a-form-item>
					
					
					
				</a-form>
				<!-- 图片管理器 -->
				<resources ref="resources"  @getimgpath="getimgpath"></resources>
			</template>


		</a-modal>
	</div>
</template>

<script>
	import resources from "../resoureces.vue"
	export default {
		components: {
			resources
		},
		props: {
			record: Object
		},
		computed: {
			// 级联选中默认
			cascader() {
				if (this.record.shop) {
					let arr = []
					arr.push(this.record.shop[0].value)
					arr.push(this.record.shop[0].children[0].value)
					arr.push(this.record.shop[0].children[0].children[0].value)
					return arr
				}
			},

		},
		data() {
			return {
				show: false,
				isresources: false,
				form: this.$form.createForm(this, {
					name: 'coordinated'
				}),
			}
		},

		created() {

		},
		methods: {
			// 获取类型
			gettype(e) {
				// console.log(e, "类型");
				this.type = e.target.value.toString() 
				console.log(this.type, "类型");
			},
			// 获取商品
			getcascader(e) {
				console.log(e, "获取商品");
			},
			// 获取分类
			getselect(e) {
				console.log(e, "获取选中分类id");
			},
			// 打开图片管理器
			openresources(btn) {
				this.witchbtn  = btn
				// this.isresources = true
				this.$refs.resources.visibles = true
			},

			// 获取更改图片路径
			getimgpath(val) {
				// 收集数据集
				this.$emit("changeimg", val)
			},
			comfirm(e) {
				console.log(e);
				const form = this.$refs.collectionForm.form;
				form.validateFields((err, values) => {
					if (err) {
						return;
					}
					console.log('Received values of form: ', values);
					// 执行提交方法
					this.$emit("modifynav", values)
				});
			},
			cancel(e){
				let pagination = {
					pageSize:4,
					current:1,
					totalPage:0,
					total:0,
					keyword:"",
					platform:""
				}
				this.$emit("gettabledata",pagination)
			}
		}
	}
</script>

<style scoped lang="less">

</style>
